import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../components/LoadingScreen';

const CoursesComponent = React.lazy(() => import('./components/CoursesList'));

const CoursesList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <CoursesComponent />
      </Suspense>
    </div>
  );
}

export default CoursesList;